// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"modal_modalWrapper__qMuZZ"};